import React from "react";
import { useNavContext } from "../context-api/nav-context";

const Intro = ({ data }) => {
  const { introTitle, introText } = data[1];
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="intro" onMouseOver={closeNavbarMenu}>
      <div className="section-wrapper">
        <div className="content-container">
          <h2 className="title">{introTitle}</h2>
          <p className="subtitle">{introText}</p>
        </div>
      </div>
    </section>
  );
};

export default Intro;
